import config from 'config';

const VIMEO_URL = config.get('public.vimeoURL');

const fetchVideoThumbnail = async videoUrl =>
  await (await fetch(`${VIMEO_URL}${videoUrl}`)).json();

export default fetchVideoThumbnail;
